import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import OkapiProducts from '../../../media/img/products/Okapi.png'
import OlaweeProducts from '../../../media/img/products/olawee.png'
import './productsDaroma.scss'

const ProductsDaroma = () => {
    const { t } = useTranslation();
    const headerRefs = useRef([]);
    const lineRefs = useRef([]);
    const buttonRefs = useRef([]);

    const productsDaroma = [
        {
            id: 1,
            icon: OkapiProducts,
            title: "OKAPi",
            subtitleKey: "products.daroma.okapiSubtitle",
            descKey: "products.daroma.okapiDesc",
            link: "https://www.okapi-roi.com/"
        },
        {
            id: 2,
            icon: OlaweeProducts,
            title: "OLAWEE",
            subtitleKey: "products.daroma.olaweeSubtitle",
            descKey: "products.daroma.olaweeDesc",
            link: "https://www.olawee.com/"
        }
    ];

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 500px 0px'
        };

        const headerObservers = headerRefs.current.map((headerRef, index) => {
            if (!headerRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const direction = index % 2 === 0 ? 'right' : 'left';
                        entry.target.classList.add(`productDaroma__media-${direction}-visible`);
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(headerRef);
            return observer;
        });


        return () => {
            headerObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        const buttonObservers = buttonRefs.current.map((buttonRef) => {
            if (!buttonRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(`conten__button-visible`);
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(buttonRef);
            return observer;
        });


        return () => {
            buttonObservers.forEach(obs => obs?.disconnect());
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className="productDaroma-info">
            <div className='productDaroma__header'>
                <h1 className="content__title-backgroundDark">{t('products.daroma.title')}</h1>
                <div
                    ref={el => lineRefs.current[0] = el}
                    className="content__title-line"
                />
            </div>
            <div className='productDaroma__container'>
                {productsDaroma
                    .map((product, index) => (
                        <div className="productDaroma__container-product" key={product.id}>
                            <div className={`productDaroma__section ${index % 2 !== 0 ? 'reverse' : ''}`}>
                                <div
                                    ref={el => headerRefs.current[index] = el}
                                    className={`productDaroma__media ${index % 2 !== 0 ? 'reverse-text productDaroma__media-left' : 'productDaroma__media-right'}`}
                                >
                                    <div
                                        className={`productDaroma__header-product ${index % 2 !== 0 ? 'reverse-text' : ''}`}
                                    >
                                        
                                    </div>
                                    <div className='productDaroma__img-container'>
                                        <img
                                            src={product.icon}
                                            alt={product.title}
                                            className={`productDaroma__image ${index % 2 !== 0 ? 'reverse-text' : ''}`}
                                        />
                                    </div>
                                </div>
                                <div className="productDaroma__content">
                                    <h2 className="productDaroma__title">{product.title}</h2>
                                    <h4 className="productDaroma__subtitle">{t(product.subtitleKey)}</h4>
                                    <p className="productDaroma__text content__text-title-backgroundDark" style={{ whiteSpace: "pre-line" }}>{t(product.descKey)}</p>
                                </div>
                            </div>
                            {index !== productsDaroma.length - 1 && <hr className="divider diverdermedia" />}
                        </div>
                    ))}
            </div>
        </div>
    );
};


export default ProductsDaroma